
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import Logo from '../base/Logo';

export default function Footer() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const quickLinks = [
    { path: '/', labelKey: 'nav_home' },
    { path: '/about', labelKey: 'nav_about' },
    { path: '/#contact', labelKey: 'nav_contact' },
    { path: '/apply', labelKey: 'nav_apply' },
    { path: '/privacy', labelKey: 'footer_privacy_policy' },
    { path: '/terms', labelKey: 'footer_terms_of_service' },
    { path: '/articles', labelKey: 'footer_articles' }
  ];

  const services = [
    { key: 'footer_service_influencer' },
    { key: 'footer_service_advertising' },
    { key: 'footer_service_analytics' },
    { key: 'footer_service_strategy' }
  ];

  const handleNavClick = (path: string) => {
    if (path.startsWith('/#')) {
      const sectionId = path.replace('/#', '');
      navigate('/');
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }, 100);
    } else if (path === '/privacy' || path === '/terms' || path === '/about' || path === '/apply') {
      navigate(path);
      setTimeout(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }, 100);
    } else {
      navigate(path);
    }
  };

  // 检查是否为cn域名
  const isCnDomain = () => {
    const hostname = window.location.hostname;
    return hostname.endsWith('.cn');
  };

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid md:grid-cols-4 gap-8">
          {/* 公司信息 */}
          <div className="md:col-span-1">
            <div className="mb-4">
              <Logo size="medium" showText={true} className="text-white" />
            </div>
            <p className="text-gray-400 mb-6">
              {t('company_desc')}
            </p>
            <div className="flex space-x-4">
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-wechat-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-mail-line text-lg"></i>
              </a>
              <a href="#" className="w-10 h-10 bg-gray-800 rounded-lg flex items-center justify-center hover:bg-gray-700 transition-colors cursor-pointer">
                <i className="ri-linkedin-line text-lg"></i>
              </a>
            </div>
          </div>

          {/* 快速链接 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer_quick_links')}</h4>
            <ul className="space-y-2">
              {quickLinks.map((link) => (
                <li key={link.path}>
                  <button
                    onClick={() => handleNavClick(link.path)}
                    className="text-gray-400 hover:text-white transition-colors cursor-pointer"
                  >
                    {t(link.labelKey)}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* 服务 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer_services')}</h4>
            <ul className="space-y-2">
              {services.map((service, index) => (
                <li key={index}>
                  <span className="text-gray-400">
                    {t(service.key)}
                  </span>
                </li>
              ))}
            </ul>
          </div>

          {/* 联系信息 */}
          <div>
            <h4 className="text-lg font-semibold mb-4">{t('footer_contact_info')}</h4>
            <div className="space-y-3">
              <div className="flex items-center">
                <i className="ri-mail-line mr-3 text-gray-400"></i>
                <span className="text-gray-400">business@koluno.com</span>
              </div>
              <div className="flex items-center">
                <i className="ri-wechat-line mr-3 text-gray-400"></i>
                <span className="text-gray-400">ljy520155</span>
              </div>
              <div className="flex items-center">
                <i className="ri-telegram-line mr-3 text-gray-400"></i>
                <span className="text-gray-400">@koluno2020</span>
              </div>
            </div>
          </div>

        </div>

        <div className="border-t border-gray-800 mt-12 pt-8">
          <div className="flex justify-between items-center">
            <p className="text-gray-400 text-sm">
              © 2024 {t('company_name')}. {t('footer_all_rights_reserved')}.
            </p>
          </div>
          
          {/* 备案信息 - 仅在cn域名显示 */}
          {isCnDomain() && (
            <div className="mt-4 text-center">
              <p className="text-gray-500 text-xs">
                <a 
                  href="https://beian.miit.gov.cn/" 
                  target="_blank" 
                  rel="noopener noreferrer"
                  className="hover:text-gray-400 transition-colors"
                >
                  蜀ICP备2025167234号-1
                </a>
              </p>
            </div>
          )}
        </div>

      </div>
    </footer>
  );
}
